export default __webpack_public_path__ + "error_user.15ad4cd.svg";